import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class StoreNameObservable {
    private storeName = new BehaviorSubject(new String());
    storeNameStream$ = this.storeName.asObservable();

    constructor() {
    }

    updateStoreName(storeName: String) {
        this.storeName.next(storeName)
    }

    getStoreName() {
        return this.storeName
    }
}